export default "__VITE_ASSET__f1b685de__"